<template>
    <!-- <el-dialog class="messageBtm" :title="msgs.title" :modal="false" v-draggable width="350px" @close="resetFirst"
        :visible.sync="showModal" :close-on-click-modal="false"> -->
    <div class="ordin" v-if="showModal">
        <div class="title">
            <div> {{msgs.title}}</div>
            <div style="font-size: 30px; color: #ccc;cursor: pointer;" @click="showModal=false">×</div>
        </div>
        <div class="time">
            {{msgs.createTime}}
        </div>
        <div v-html="msgs.content" style="padding-bottom: 20px;  text-indent: 2em;">

        </div>
    </div>

    <!-- </el-dialog> -->

</template>
<script>

    export default {
        name: "dragModal",
        components: {},
        data() {
            return {
                showModal: false, //是否打开弹窗 非0打开
                left: "",
                top: "",
                direction: 'rtl',
                activeIndex: 1,
                connection: null,
                msgs: [],
                dataInfo: { status1: "off", status2: "off" }

            };
        },
        props: {


        },

        computed: {},


        methods: {


            resetFirst() {
                this.showModal = false
            },
            show(obj) {
                this.msgs = obj

                let date = new Date(this.msgs.createTime);
                let options = {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false,
                    timeZone: 'Asia/Shanghai'
                };
                let formattedDate = date.toLocaleString('zh-CN', options).replace(/\//g, '-').replace(',', '');
                this.msgs.createTime = formattedDate
                this.showModal = true
            },
        },
    };
</script>
<style rel="stylesheet/scss" lang="less" scoped>
    /deep/ .el-dialog {
        position: absolute;
        /* right: 0; */
        left: 76vw;
        /* bottom: 100px; */

    }

    .el-menu-demo .el-menu-item,
    .el-submenu__title {
        height: 35px;
        line-height: 35px;

    }

    .el-menu-demo {
        padding: 0 20px;
    }

    //图片
    .left_image {
        width: 40px;
        height: 40px;
        position: absolute;
        top: 50%;
        left: 10px;
        margin-top: -20px;
        border-radius: 50%;
    }

    //每一条
    .notification_text {
        width: 100%;
        height: 80px;
        border-bottom: 1px #ccc solid;
        position: relative;
    }

    //底部按钮
    .bottom_button {
        width: 330px;
        height: 50px;
        border-top: #ccc 1px solid;
        position: absolute;
        bottom: 0;
        left: 0;
    }

    //左右按钮
    .bottom_button_left,
    .bottom_button_right {
        display: inline-block;
        width: 164px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
    }

    //左按钮
    .bottom_button_left {
        border-right: solid 1px #ccc;
    }

    //左按钮
    .bottom_button_left:hover {
        color: #40aaf7;
    }

    //右按钮
    .bottom_button_right:hover {
        color: #40aaf7;
    }

    //文字部分位置
    .text {
        display: inline-block;
        position: absolute;
        top: 5px;
        left: 65px;
    }

    //内容部分超出隐藏，给滚动条
    .box {
        overflow: auto;
        height: 400px;
        /* margin-bottom: 37px; */
    }

    //滚动条的样式
    ::-webkit-scrollbar {
        //滚动条宽高
        width: 5px;
        height: 10px;
    }

    ::-webkit-scrollbar-thumb {
        //滚动条颜色和圆角
        background-color: #dbd9d9;
        border-radius: 3px;
    }

    /deep/ .el-dialog__header {
        background-color: #f1f3f4 !important;
        padding-bottom: 16px !important;
    }

    .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: center;
        font-size: 20px;
        font-weight: 600;
        /* margin: 10px 0; */

    }

    .time {
        text-align: right;
        color: f9f9f9;
        margin-bottom: 10px;
        margin-right: 10px;
    }

    .ordin {
        width: 250px;
        position: absolute;
        bottom: 30px;
        right: 30px;
        background-color: #fff;
        z-index: 99999;
        box-shadow: 1px 1px 10px 1px #ccc;
        padding: 6px 20px;
        border-radius: 10px;
    }
</style>